module.exports="#define GLSLIFY 1\nuniform float uOpacity;\n\nvarying vec3 vColor;\nvoid main() {\n  gl_FragColor = vec4(vColor, uOpacity);\n}";